// extracted by mini-css-extract-plugin
export var card = "_81-1";
export var container = "_81-0";